import http from './http';

const updateAds = (websiteId, payload) => {
  return http.post(`/website/${websiteId}/activeAds`, payload);
};

const loadWebsite = (websiteId) => {
  return http.get(`/website/${websiteId}`);
};

export default { updateAds, loadWebsite };
export { updateAds, loadWebsite };
